import React from 'react'
import { useSelector } from 'react-redux'
import { selectGeoentityRubricId, selectSelectedGeoentity } from '../../../store/geoentity/geoentity.selectors'
import { selectIsItineraryUniverse } from '../../../store/history/history.selectors'
import { SPD_GEOENTITY_GOTO } from '../../analytics/BiTagger'
import { PAGE_POI_NAME } from '../../analytics/PageTagsService'
import GoToItineraryButton from '../../genericComponents/GoToItineraryButton'
import AddPoiStepButton from '../../itinerary/steps/AddPoiStepButton'
import s from './GeoentityCardButtons.less'
import SharePoiButton from '../../itinerary/shareToMobile/SharePoiButton'
import { isGE, isPE } from '../../Device'

const GeoentityCardButtons = () => {
  const rubricId = useSelector(selectGeoentityRubricId)
  const geoentity = useSelector(selectSelectedGeoentity)
  const isItinerary = useSelector(selectIsItineraryUniverse)

  return (
    <div className={s.buttonsSection}>
      {((isItinerary && isPE()) || isGE()) && (
        <GoToItineraryButton
          location={geoentity}
          tagProps={{
            tagInfo: {
              ancrage: PAGE_POI_NAME,
              catId: rubricId
            }
          }}
          biProps={{
            tagId: SPD_GEOENTITY_GOTO,
            params: { geoentity: geoentity.id }
          }}
        />
      )}
      {isItinerary ? <AddPoiStepButton location={geoentity} /> : <SharePoiButton />}
    </div>
  )
}

export default GeoentityCardButtons
